const frontUrl = process.env.REACT_APP_FRONTEND_URL;

export default frontUrl;
